import { LanguageCode, languageCodeToBCP47 } from '@repo/constants';

const isLanguageCode = (code: string): code is LanguageCode =>
  Object.prototype.hasOwnProperty.call(languageCodeToBCP47, code);

/**
 * i18n short code(ko/en/...)를 Accept-Language 헤더 값(BCP47)으로 변환.
 * 매핑 불가 시 undefined를 반환하여 호출 측이 헤더를 세팅하지 않도록 함
 * (이 경우 브라우저가 navigator.languages 기반의 기본값을 자동으로 전송).
 */
export const getAcceptLanguage = (code?: string | null): string | undefined => {
  if (!code) return undefined;
  const base = code.split('-')[0]?.toLowerCase() ?? '';
  if (isLanguageCode(base)) return languageCodeToBCP47[base];
  return undefined;
};
